import { Component, computed, input } from '@angular/core';
import { computeFillPercent } from '../v3-scores-overview/score-fill';

// V3ScoresOverview's mobile score row — label + bar + value/max. See v3-scores-overview/CLAUDE.md.
@Component({
  selector: 'app-v3-score-bar',
  imports: [],
  standalone: true,
  templateUrl: './v3-score-bar.html',
  styleUrl: './v3-score-bar.scss',
})
export class V3ScoreBar {
  readonly label = input.required<string>();
  readonly value = input.required<number>();
  readonly max = input.required<number>();
  /** V3 score-tier CSS custom property name (e.g. '--v3-score-good'). */
  readonly colorVar = input.required<string>();
  readonly isRatingSuspended = input(false);

  readonly fillPercent = computed(() =>
    computeFillPercent(this.value(), this.max(), this.isRatingSuspended()),
  );
}
